module.exports = __webpack_public_path__ + "img/infoQRView1_20.7773901d.svg";